import React,{useState,useRef,useEffect} from 'react'
import { Formik, Field } from 'formik'
import axios from 'axios'
import useOnclickOutside from "react-cool-onclickoutside"
import { Form, Input, TextArea, Button, Select, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Segment } from 'semantic-ui-react'
import { WindowReload, WindowURL, WindowLocation, RouteURL } from '../../../../services/redirect'
import Spinner from '../../../../services/spinner'
import AlertMessage from '../../../../services/alert'


export default function SendEmail(props){

  /*----------------------------------------
    HANDLE CLICK OUTSIDE ELEMENT
  -----------------------------------------*/

  const handleClickAway = useOnclickOutside(() => CallbackModal({close:true}));
  function CallbackModal(data){
    if(spinner){
      return false;
    }
    props.callback(data);
  }


  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(false);
  const [spinoverlay,setspinoverlay] = useState(false);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
      if(data.reload){
        WindowReload();
      }
    }
  }

  /*------------------------------------------------------
    NOTIFY
    {intent:'info',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}}
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
      if(data.reload){
        WindowReload();
      }
    }
  }




  function handleSubmitForm(){

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Processing',text:"Sending report, please wait..."}});
    setspinoverlay(true);

    let formData = new FormData();
    formData.append('type','sendMail');
    formData.append('sentby',2);
    axios.post('/admin/reports/send-mail/weekly/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setspinoverlay(false);

      if(obj=='1'){
        setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Weekly reports successfully sent.'}});
        setnotify(true);
        setTimeout(function() {
          CallbackModal({close:true});
          setnotify(false);
        },3000);
        return false;
      }else{
        setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Something Wrong!',text:'Failed to connect through the server.'}});
        setnotify(true);
        setTimeout(function() {setnotify(false);},3000);
        return false;
      }


    })
    .catch(function (error){
      setspinoverlay(false);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
  }


  /*----------------------------------------
    GET EMAILS
  -----------------------------------------*/
  const [status, setStatus] = useState(true);
  const [emails, setEmails] = useState([]);
  function handleGetEmails(status){

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setspinoverlay(true);

    let formData = new FormData();
    formData.append('type','getEmails');
    formData.append('status',status);
    axios.post('/admin/reports/processed-orders/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      if(obj.length>0){
        setStatus(false);
        setEmails(obj);
      }
      
      setspinoverlay(false);


    })
    .catch(function (error){
      setspinoverlay(false);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
  }




  useEffect(()=>{
    handleGetEmails(1);
  },[]);


  return (
    <React.Fragment>
           <Form>
            <div className="modalpanel-wrapper">
              <div className="modalpanel-container small center animate__animated animate__slideInUp animate__faster" ref={handleClickAway}>

              {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
              {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}
              {spinoverlay&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}

              {/*---------------------------------------------------------
                 HEADER
                --------------------------------------------------------*/}
                 <div className="modalpanel-header">
                    <div>
                      <h2>Send Processed Orders</h2>
                    </div>
                    <div onClick={()=>CallbackModal({close:true})}><i className="uil-multiply"></i></div>
                 </div>


                 {/*---------------------------------------------------------
                    BODY
                   --------------------------------------------------------*/}

                 <div className="modalpanel-body">
                    <div className="modalpanel-content">

                        <div class="alert-message left info infohasborder">
                          <div><i class="info circle icon"></i></div>
                          <div>
                            <p>List of email addresses that can receive weekly processed order reports when you click the confirm button.</p>
                          </div>
                        </div>

    
                        {!spinner&&<Table striped>
                          <Table.Body>
                          {emails.length==0&&<Table.Row negative><Table.Cell textAlign="center">No email found</Table.Cell></Table.Row>}
                          {emails.map(function(data, key){
                            return <Table.Row key={key}>
                              <Table.Cell>{data.email}</Table.Cell>
                            </Table.Row>
                          })}
                          </Table.Body>
                        </Table>}


                    </div>
                 </div>


                 {/*---------------------------------------------------------
                    FOOTER
                   --------------------------------------------------------*/}

                 <div className="modalpanel-footer">
                     <Button disabled={status} size="medium" fluid className='BlueButton strong' content='CONFIRM SEND' onClick={() => handleSubmitForm()}/>
                 </div>


              </div>{/*.modalpanel-container*/}
            </div>
          </Form>
    </React.Fragment>
  )
}
